export default "__VITE_ASSET__DDRF_i$J__"